<template>
    <div>
        <section class="itb-references-alike-set" style="margin-top: 3.7rem">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-12">
                        <div class="row">
                            <div
                                class="col-12 col-md-4"
                                v-for="(realization, index) in realizations"
                            >
                                <router-link
                                    :to="{
                                        name: 'realizationDetail',
                                        params: {
                                            categoryAlias: mainCategory.alias,
                                            realizationAlias:
                                                realization.id +
                                                '-' +
                                                realization.alias
                                        }
                                    }"
                                    class="text-decoration-none"
                                >
                                    <div
                                        class="card w-100 itb-margin-bottom itb-lazy-loading-bg"
                                        v-lazy:background-image="
                                            realization.image
                                                ? '/uploads/' +
                                                  realization.image
                                                : null
                                        "
                                    >
                                        <div class="card-body d-flex p-0">
                                            <div
                                                class="itb-text align-self-end w-100"
                                            >
                                                <h3 class="mb-0">
                                                    {{ realization.name }}
                                                </h3>
                                                <p class="itb-h3-subtitle">
                                                    {{ realization.location }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    class="btn btn-secondary itb-btn-icon"
                    @click="scrollToElement('itb-contact-form')"
                >
                    {{ $t("realizations.i_want_proposal_free") }}
                    <img
                        src="/images/icons/4soft_icon_angle-right.svg"
                        :alt="$t('realizations.i_want_proposal_free')"
                        class="itb-icon itb-angle-right-icon"
                    />
                </button>
            </div>
            <BenefitsBar />
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BenefitsBar from "../components/BenefitsBar";

export default {
    data() {
        return {
            mainCategory: [],
            realizations: []
        };
    },

    components: {
        BenefitsBar
    },

    mounted() {
        axios
            .get(
                `/getRealizationsByCategoryPage/${this.$route.params.categoryAlias}`
            )
            .then(response => {
                this.pageParams = response.data.params;
                this.realizations = response.data.realizations;
                this.mainCategory = response.data.mainCategory;
                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams"
        })
    },

    methods: {
        ...mapActions(["setPageParams"]),
        scrollToElement(elementId) {
            this.$parent.scrollToElement(elementId);
        }
    }
};
</script>
